enum IFeatureSections {
  EXTERIOR = 'exterior',
  INTERIOR = 'interior',
  ACCESSORY_PACK = 'accessoryPack',
  ACCESSORY = 'accessory',
  SERVICE_PLAN = 'servicePlan',
}

export default IFeatureSections;
